export interface ShoppingListsResponse {
    /** Text that should be displayed in the header of the widget */
    title: string;
    /** url that should be linked in the header, next to the title */
    link: string;
    /** text for the "title" attribute of that link (visible on mouseover) */
    linkTitle: string;
    /** array of shopping lists. For details of the individual items see "List" */
    lists?: List[];
    /** text that should be displayed when there are no shopping lists (only required when there are no shopping lists) */
    noListsText?: string;
    /** url for the button below the noListsText (only required when there are no shopping lists) */
    createListLink?: string;
    /** text for the button to create a new list */
    createList?: string;
    /**
     * collection of translated strings that will be used in multiple places in the widget.
     * Details see "Messages". (only required when there are lists)
     **/
    messages?: Messages;
    /** is true when the myTrumpf user-data is not yet complete and the widget can therefore not display any data */
    noData?: boolean;
    /** text to display when the myTrumpf user-data is not yet complete. This may contain html tags like <strong> */
    noDataText?: string;
}

export interface Messages {
    /** Text that is displayed next to the lastChange date */
    lastChange: string;
    /** Text for the button to go to the detail page */
    details: string;
    /** text for addListToCart button */
    addListToCart: string;
    /** text that is displayed next to the number of articles */
    articleLabel: string;
    /** text for the sorting dropdown (hidden behind the cog icon) */
    sortByLabel: string;
    /** label text for the alphabetical sorting order */
    alphabeticalLabel: string;
    /** label text for the descending alphabetical sorting order */
    alphabeticalDescLabel: string;
    /** label text for the mostRecentlyChanged sorting order */
    recentlyChangedLabel: string;
    /** label text for the mostRecentlyChanged descending sorting order */
    recentlyChangedDescLabel: string;
}

export interface List {
    /** title of the list, this is displayed on top of the individual entry */
    title: string;
    /** formatted date string of the last change */
    lastChange: string;
    /** link to the shopping list detail page */
    listLink: string;
    /** link to add the list to the cart */
    addListToCartLink: string;
    /** amount of articles on the list */
    amount: number;
}
